import LogoutPage from './LogoutPage';
import connect from './connect';

export default connect(LogoutPage);



// WEBPACK FOOTER //
// ./src/app/LogoutPage/index.js